import { Button } from '@/components/Button';

const openDemo = () => {
  window.open('https://demo.furnitech.app', '_blank', 'noopener,noreferrer');
};

export const Demo = () => {
  return (
    <section className="section-container">
      <div className="card flex flex-col gap-8 md:gap-12">
        {/* Section header */}
        <div className="section-title">
          <div className="section-title-prefix">product</div>
          <div className="section-title-main">Demo</div>
        </div>

        <div className="flex flex-col gap-10 lg:flex-row">
          {/* Video player */}
          <div className="relative w-full overflow-hidden rounded-[20px] shadow-lg">
            <div className="relative h-0 w-full pb-[56.25%]">
              <iframe
                className="absolute left-0 top-0 h-full w-full"
                src="https://www.youtube.com/embed/FtgV3DNUJH0"
                title="Furnitech platform walkthrough"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>

          {/* Supporting copy */}
          <div className="flex w-full flex-col gap-6 lg:max-w-[420px]">
            <p className="body-text text-balance">
              See how Furnitech brings together inspiration, configuration, and
              ordering in one fluid journey. The demo highlights the intuitive
              interface your customers experience from the very first tap.
            </p>
            <a
              className="font-button-button-1-font-family text-button-button-1-font-size font-button-button-1-font-weight uppercase tracking-wider text-primary-primary-40 underline decoration-primary-primary-30-main decoration-2 underline-offset-4 transition-colors hover:text-primary-primary-30-main"
              href="https://www.youtube.com/watch?v=FtgV3DNUJH0"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open the video on YouTube
            </a>
            &nbsp;
            <div className="w-full">
              <Button title="See the Product in Action" onClick={openDemo} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
